query pendingChangesForRegeneration($companyId: ID!) {
  pendingChangesForRegeneration(companyId: $companyId)
}
